import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from 'src/app/services/subscription/subscription.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.css']
})
export class CurrencyComponent implements OnInit {



  Submitted: boolean = false;
  CurrencyList: any;
  
  constructor(private subcriptionService: SubscriptionService, private LookupService: LookupService,
     public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

     GetAllCurrency() {
      this.subcriptionService.GetAllCurrency(JSON.stringify(this.PackageModel)).subscribe((data: any) => {
        this.CurrencyList = data.CurrencyList;
      });
  
    }
  PackageModel = {
    CurrencyCode:'',
    CurrencyName:'',
    CurrencyRate:0,
    ExchangeRate:0,
  };

  CurrencyModel = {
    CurrencyID:0,
    CurrencyRate:0,
    ExchangeRate:0,
    };
  
  ClearPackage() {
    this.Submitted = false;
    this.PackageModel.CurrencyRate = 0;
    this.PackageModel.ExchangeRate = 0;
    this.PackageModel.CurrencyCode = '';
    this.PackageModel.CurrencyName = '';
  };


  validation() {
    return this.CurrencyModel.CurrencyID == 0;
  }


 
  SaveCurrency() {
   
    this.Submitted = true;
    if (!this.validation()) {
      this.spinnerService.show();
      this.subcriptionService.SaveCurrency(JSON.stringify(this.CurrencyModel)).subscribe((data: any) => {
        this.GetAllCurrency();
        this.GetCurrencyLog();
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);

      });
    }
  }


  EditCurrency(obj) {   
    this.CurrencyLogList=[];
    this.CurrencyModel.CurrencyID = obj.CurrencyID;
    this.PackageModel.CurrencyRate = obj.CurrencyRate;
    this.PackageModel.ExchangeRate = obj.ExchangeRate;
    this.PackageModel.CurrencyName = obj.CurrencyName;
    this.PackageModel.CurrencyCode = obj.CurrencyCode;
    this.CurrencyModel.CurrencyRate = obj.CurrencyRate;
    this.CurrencyModel.ExchangeRate = obj.ExchangeRate;

    this.GetCurrencyLog();
   
  };

  ngOnInit() {
    this.GetAllCurrency();
  }

  CurrencyLogList=[];
  GetCurrencyLog() {
    this.subcriptionService.GetCurrencyLog(this.CurrencyModel.CurrencyID).subscribe((data: any) => {
      this.CurrencyLogList = data.CurrencyLogList;
    });

  }
}
